<template>
  <div>
    <button class="button" @click="pay">Payer avec Stripe et imprimer</button>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";

export default {
  props: {
    fileDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async pay() {
      try {
        const response = await fetch(process.env.VUE_APP_URL_CREATE_SESSION, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            printId: this.fileDetails.fileName, // Utilisation du nom de fichier
            price: this.fileDetails.price, // Prix de base
            printType: this.fileDetails.printType, // Type d'impression (nb ou color)
            rectoverso: this.fileDetails.rectoverso, // Option recto verso
            selectedPrinter: this.fileDetails.selectedPrinter, // Option recto verso
          }),
        });

        const session = await response.json();

        const stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
        await stripe.redirectToCheckout({
          sessionId: session.id,
        });
      } catch (error) {
        console.error(
          "Erreur lors de la création de la session Stripe :",
          error
        );
      }
    },
  },
};
</script>
